import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox, FormControlLabel, FormHelperText } from '@mui/material';

const CheckboxLabel = ({ sx, error, controlSx, indeterminate, ...props }) => {
    return (
        <>
            <FormControlLabel
                sx={theme => ({
                    fontSize: '16px',
                    color: 'common.black',
                    alignItems: 'flex-start',
                    mb: 2,
                    mr: 0,
                    '&.Mui-FormControlLabel-label': { pt: '2px' },
                    ...(typeof sx === 'function' ? sx(theme) : sx),
                })}
                {...props}
                control={
                    <Checkbox
                        sx={theme => ({
                            paddingY: '2px',
                            ...(typeof controlSx === 'function' ? controlSx(theme) : controlSx),
                        })}
                        indeterminate={indeterminate}
                        disableRipple
                    />
                }
            />
            {!!error && <FormHelperText error={!!error}>{error}</FormHelperText>}
        </>
    );
};

CheckboxLabel.propTypes = {
    sx: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
    controlSx: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
    indeterminate: PropTypes.bool,
    error: PropTypes.string,
};

export default CheckboxLabel;
